import React from 'react'
import Back from '../../common/Back'
import RecentCard from '../Home/Recent/RecentCard'
import i from '../images/background.png'
const Blog = () => {
  return (
    <>
      <section className="blog-out mb ">
        <Back name='Blog' title='Blog Grid - Our Blog' cover={i}/>
        <div className="container recent">
            <RecentCard/>
        </div>
      </section>
    </>
  )
}

export default Blog
